export class GroupModel {
  id?: number;
  name: string;

  constructor() {
    this.name = "";
  }
}